import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Icon } from "rsuite";
// import { PlecaInfo } from "../plecaInfo/plecaInfo";
import Logo from "../../assets/imgs/RedPay.png";
import { settingService } from "../../services/setting.service";
import { accountService } from "../../services/account.service";
import { useDispatch } from "react-redux";
import { setUserSetting } from "../../store/actions";
import menu from "../../data/menu.json";
import { useTranslation } from "react-i18next";
import "./header.scss";
import LanguageSwitcher from "../../language/languageSwitcher";

export const Header = (props) => {
    const dispatch = useDispatch();
    const [userSettings, setUserSettings] = useState({});

    const { t, i18n } = useTranslation();
    useEffect(() => {
        settingService.getSettingSite().then((result) => {
            setUserSettings(result);
            dispatch(setUserSetting(result));
        });
    }, [sessionStorage["rp_company"]]);

    const environmentTranslations = {
        "MODO PRODUCCIÓN": "environment.production",
        "MODO PRUEBAS": "environment.sandbox",
    };

    const MyLink = React.forwardRef((props, ref) => {
        const { href, as, ...rest } = props;
        return <Link to={href} as={as} ref={ref} {...rest}></Link>;
    });

    const NavLink = (props) => (
        <Dropdown.Item componentClass={MyLink} {...props} />
    );

    const Integration = () => {
        const data = menu.find(
            (a) => a.section == "Dropdown" && a.roles.includes(props.role)
        );
        return data != undefined ? (
            <div>
                <Dropdown.Item divider />
                <NavLink href={data.url}>{i18n.language === 'en' ? data.nameEn : data.nameEs}</NavLink>
            </div>
        ) : null;
    };

    return (
        <>
            <header className="wrapper_header">
                <div className=" content_header">
                    <div className="box_logo">
                        <span
                            className={`btn_menu ${props.activeBtn}`}
                            onClick={props.MyFunMenu}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                        <Link to="/home">
                            <img
                                src={Logo}
                                alt="Red Pay MX, Pagos online, visa, mastercard, oxxo pay"
                            />
                        </Link>
                    </div>
                    <div className="text-center box_actions">
                        <span className="tag_mode">
                            <span className="drop"></span>
                            <span>{t(environmentTranslations[userSettings.environment] || userSettings.environment)}</span>
                        </span>
                        <Dropdown
                            className="box_drop_user"
                            title={
                                <span className="name_business_drop">
                                    {userSettings.companyName}{" "}
                                </span>
                            }
                            trigger={"click"}
                            icon={<Icon icon="building-o" />}
                            placement="bottomEnd"
                        >
                            <Dropdown.Item>
                                <Icon icon="user-o" /> {t('header.hi')},{" "}
                                <span className="fw-900">{userSettings.companyName}</span>
                            </Dropdown.Item>
                            <NavLink href="/business">{t('header.myBusinesses')}</NavLink>
                            <Integration />
                            <Dropdown.Item divider />
                            <NavLink href="/statment">{t('header.statment')} {<Icon icon="file-pdf-o" />}</NavLink>
                            <Dropdown.Item divider />
                            <NavLink href="/my-account">{t('header.myAccount')}</NavLink>
                            <Dropdown.Item onClick={() => accountService.logout()}>
                                {t('header.logOut')}
                            </Dropdown.Item>
                        </Dropdown>
                        <LanguageSwitcher />
                    </div>
                </div>
            </header>
            {/* <PlecaInfo /> */}
        </>
    );
};
